import { AppFundaViewingRequestPointerParameterValue } from '~/scenes/Automation/Flows/Actions/Base/types.flow';

import { PARAMETER_VALUE_TYPE } from '../../../constants';

export default (): AppFundaViewingRequestPointerParameterValue => ({
  type: PARAMETER_VALUE_TYPE.EVENT_CONTACT_APP_FUNDA_VIEWINGREQUEST_POINTER,
  variable: null,
});
